import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
  size?: 'small' | 'medium' | 'large';
}

export default function DramaCard({ drama, size = 'medium' }: DramaCardProps) {
  return (
    <Link
      to={`/article/${drama.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
        <img
          src={drama.coverImage}
          alt={drama.title}
          title={`${drama.title} - 星辰影院免费电视剧`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {drama.isHot && (
            <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              热播
            </span>
          )}
          {drama.isNew && (
            <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50 dark:text-foreground-950 whitespace-nowrap">
              新剧
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-background-950/80 text-primary-400 whitespace-nowrap">
            {drama.rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-foreground-100 line-clamp-2">{drama.description}</p>
        </div>
      </div>
      <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors duration-300 line-clamp-1">
        {drama.title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{drama.year}</span>
        <span className="text-foreground-600">·</span>
        <span className="text-xs text-foreground-500">{drama.status}</span>
      </div>
    </Link>
  );
}